/* ty-eilat-only — «יש:» בקוביית הוד השרון שאזלה. הכרעת יובל 04.10.2026.
 * לחיצה בוחרת את הנפח בבורר הגרסאות, כאילו הלקוח לחץ עליו בעצמו, וכך הזרימה הרגילה של הערכה רצה.
 * 🔴 window.__tyBranchSel = 'hod' לפני הלחיצה: ה-MutationObserver ב-buy-buttons.liquid שומר בחירת אילת
 *    בין החלפות וריאנט, וגם בחירה שהשרת עשה לבד נרשמת שם כ«אילת». הלקוח ביקש כאן את המרכז במפורש.
 * הכלי: shopify-agent/scripts/apply-eilat-only-2026-10-04.mjs
 */
(function () {
  if (window.__tyEilatOnly) return;
  window.__tyEilatOnly = true;
  /* 🔴 אילת שהשרת בחר לבד (כי הגרסה אזלה בהוד) לא נדבקת. נמדד 04.10.2026 בחי: 512GB כחול ⟵ אילת אוטומטית,
     ואז שחור (יש בהוד) ⟵ אילת נשארה, והכפתור «לשריון באילת». ה-MutationObserver ב-buy-buttons.liquid רושם
     גם בחירה של השרת כבחירת הלקוח. כאן: רק לחיצה של הלקוח על קוביית אילת (או על גרסה בתיבת «זמין באילת») נשמרת. */
  var userEilat = false;
  function onPickEv(ev) {
    var t = ev.target.closest && ev.target.closest('[data-ty-pick], [data-tyeo-chip]');
    if (!t) return;
    if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return;
    userEilat = t.hasAttribute('data-tyeo-chip') || t.getAttribute('data-ty-pick') === 'eilat';
  }
  document.addEventListener('click', onPickEv, true);
  document.addEventListener('keydown', onPickEv, true);
  document.addEventListener('change', function (ev) {
    if (!ev.target.closest || !ev.target.closest('variant-selects, variant-radios')) return;
    if (!userEilat) window.__tyBranchSel = 'hod';
  }, true);
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ty-eo-val]');
    if (!b) return;
    ev.preventDefault();
    var opt = b.getAttribute('data-ty-eo-opt') + '-';
    var val = b.getAttribute('data-ty-eo-val');
    var scope = b.closest('.product__info-container') || document;
    window.__tyBranchSel = 'hod';
    userEilat = false;
    var inputs = scope.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.name.indexOf(opt) !== 0 || inp.value !== val) continue;
      var lab = inp.id ? scope.querySelector('label[for="' + inp.id + '"]') : null;
      (lab || inp).click();
      return;
    }
    var sels = scope.querySelectorAll('variant-selects select');
    for (var j = 0; j < sels.length; j++) {
      var s = sels[j];
      if ((s.name || '').indexOf(opt) !== 0) continue;
      for (var k = 0; k < s.options.length; k++) {
        if (s.options[k].value === val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); return; }
      }
    }
  });
})();
